export enum FeatureEnum {
  PublicWebsiteSignin = 1,
  CustomerEditOwnProfile = 2,
  JobseekerEditOwnProfile = 3,
  AddAnnouncement = 4,

  AdminSignin = 6,

  ManageIndexing = 7,
  ManageSchedulerTasks = 8,
  SchedulerSignin = 9,

  UpdateCustomerWithoutModeration = 10,
  ViewCustomer = 11,
  DeleteCustomer = 12,
  LoginAsCustomer = 13,

  ViewAnnouncement = 14,
  DeleteAnnouncement = 15,

  UpdateJobseekerWithoutModeration = 16,
  ViewJobseeker = 17,
  DeleteJobseeker = 18,

  ModerateCustomer = 19,
  ModerateJobseeker = 20,
  ModerateAnnouncement = 21,

  ViewStats = 22,

  ViewSettings = 23,
  ManageAdminUsers = 24,

  ViewCvDbProducts = 25,
  RequestCvDbProduct = 26,

  ViewCvDbProductRequests = 27,
  ApproveRejectCvDbProductRequest = 28,
  TerminateActiveCvDbProduct = 29,

  ViewSubscriber = 30,

  ViewSliderBannerProducts = 31,
  RequestSliderBannerProduct = 32,

  ViewSliderBannerProductRequests = 33,
  ApproveRejectSliderBannerProductRequest = 34,
  TerminateActiveSliderBannerProduct = 35,

  AccountManager = 36,
  ManagePortfolios = 37, //check

  OwnPortfolioTransactionInitialApprove = 38,
  TransactionInitialApprove = 39,

  ManageOwnPortfolioTransactions = 40,
  ManageAllTransactions = 41,

  TransactionFinalApprove = 42,

  ViewOwnPortfolioInvoices = 43,
  ViewAllInvoices = 44,
  MergeAndUnmergeInvoices = 45,
  ApproveInvoice = 46,
  ManageInvoiceAccounting = 47,
  CancelAnnouncement = 48,
  TerminateAnnouncement = 49,

  ViewPayments = 50,
  ManagePayments = 51,

  CancelAnnouncementAfterFinalApproval = 52,

  EditInvoice = 53,

  ManageJobFairs = 54,

  ArchiveCustomer = 55,

  ViewCvBoxProducts = 56,
  RequestCvBoxProduct = 57,

  ViewCvBoxProductRequests = 58,
  ApproveRejectCvBoxProductRequest = 59,
  TerminateActiveCvBoxProduct = 60,

  CustomerViewAnnouncement = 61,
  CustomerManageJobseeker = 62,
  CustomerManageUserSettings = 63,
  CustomerEditOwnBasicProfile = 64,

  EnterSalesMonthlyPlan = 65,
  ViewSalesMonthlyPlanReport = 66,
  // 67 missing
  ViewMatchingList = 68,
  ApproveMatchingList = 69,
  ExpressApprove = 70,

  FlagAndUnflagInternalEmployeeJobseeker = 71,

  ViewCustomerBrandingProducts = 72,
  RequestCustomerBrandingProduct = 73,

  ViewCustomerBrandingProductRequests = 74,
  ApproveRejectCustomerBrandingProductRequest = 75,
  TerminateActiveCustomerBrandingProduct = 76,
}
